/* Starbound Letters — listing pages (Shopify edition): filter chips, sorting, empty state.
   Every card carries data-filters="|collection-handle|Occasion|Color" rendered by Liquid. */
(function () {
  "use strict";
  const grid = document.querySelector("[data-grid]");
  if (!grid) return;
  const cards = Array.from(grid.querySelectorAll(".product-card"));
  const countEl = document.querySelector("[data-count]");
  const emptyEl = document.querySelector("[data-empty]");
  const sortSel = document.querySelector("[data-sort]");
  const chips = Array.from(document.querySelectorAll("[data-filter-chips] .chip"));
  const active = new Set();
  const tokens = (c) => (c.dataset.filters || "").split("|").filter(Boolean);

  function matches(c) {
    if (!active.size) return true;
    const t = tokens(c);
    for (const f of active) if (t.includes(f)) return true;
    return false;
  }

  function apply() {
    let visible = 0;
    cards.forEach((c) => {
      const show = matches(c);
      c.hidden = !show;
      if (show) visible++;
    });
    if (countEl) countEl.textContent = `${visible} ${visible === 1 ? "piece" : "pieces"}`;
    if (emptyEl && cards.length) emptyEl.hidden = visible !== 0;
    if (cards.length) grid.hidden = visible === 0;
  }

  chips.forEach((chip) => {
    chip.addEventListener("click", () => {
      const f = chip.dataset.filter;
      if (active.has(f)) { active.delete(f); chip.setAttribute("aria-pressed", "false"); }
      else { active.add(f); chip.setAttribute("aria-pressed", "true"); }
      apply();
    });
  });
  const clear = document.querySelector("[data-clear-filters]");
  if (clear) clear.addEventListener("click", () => {
    active.clear();
    chips.forEach((c) => c.setAttribute("aria-pressed", "false"));
    apply();
  });

  if (sortSel) {
    const original = cards.slice();
    sortSel.addEventListener("change", () => {
      const v = sortSel.value;
      let sorted = original.slice();
      const title = (c) => c.dataset.title || "";
      const price = (c) => parseInt(c.dataset.price, 10);
      if (v === "title-asc") sorted.sort((a, b) => title(a).localeCompare(title(b)));
      if (v === "title-desc") sorted.sort((a, b) => title(b).localeCompare(title(a)));
      if (v === "price-asc") sorted.sort((a, b) => (isNaN(price(a)) ? Infinity : price(a)) - (isNaN(price(b)) ? Infinity : price(b)));
      if (v === "price-desc") sorted.sort((a, b) => (isNaN(price(b)) ? -1 : price(b)) - (isNaN(price(a)) ? -1 : price(a)));
      sorted.forEach((c) => grid.appendChild(c));
    });
  }
  apply();
})();
